<template>
  <div>
    <div class="mt-10 f12 fcc color-gray" style="background-color:white;height:46px;">—— 商品详情 ——</div>
    <div class="images">
      <img v-for="(item,index) in descPics" :src="item" :key="index" alt />
    <div
        class="mt-10 f12 fcc color-gray"
        style="background-color:white;height:46px;"
      >—— 预定流程及须知 ——</div>
      <img src="https://file.sdyxmall.com/h5/v1/public/app/img/group5.b0b24d0.png" alt />
    </div>
    <div class="context">
      <p class="big-item">一、关于发货</p>
      <p class="small-item">个工作日内发出（周末、法定节假日需顺延）个工作日内发出（周末、法定节假日需顺延）；</p>
      <p class="big-item">二、关于发货</p>
      <p class="small-item">个工作日内发出（周末、法定节假日需顺延）个工作日内发出（周末、法定节假日需顺延）；</p>
      <p class="big-item">二、关于发货</p>
      <p class="small-item">个工作日内发出（周末、法定节假日需顺延）个工作日内发出（周末、法定节假日需顺延）；</p>
      <p class="big-item">二、关于发货</p>
      <p class="small-item">个工作日内发出（周末、法定节假日需顺延）个工作日内发出（周末、法定节假日需顺延）；</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["descPics"]
};
</script>

<style>
</style>